/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useQuery } from '../../hooks/useQuery';
import dayjs from 'dayjs';

import { Button, Form, Typography } from 'antd';
const { Text } = Typography;
import { ReactComponent as Cancel } from './img/cancel-icon.svg';
import { ReactComponent as GoBackIcon } from '../../assets/go-back-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/edit-icon.svg';

import OnboardingItemFabrica from './OnboardingItemFabrica/OnboardingItemFabrica';
import OnboardingCompositeItemFabrica from './OnboardingCompositeItemFabrica/OnboardingCompositeItemFabrica';
import {
  createCompositeInputElement,
  createFormInputElement,
  deleteCompositeInputElement,
  deleteFormInputElement,
  editCompositeInputElement,
  editFormInputElement,
  getOnboardingById,
  startOnboardingEdit,
  stopOnboardingEdit,
  submitOnboarding,
} from '../../data/store/onboarding/onboardingActions';
import OnboardingActionItemFabrica from './OnboardingActionItemFabrica/OnboardingActionItemFabrica';
import { START_ONBOARDING_EDIT } from '../../data/store/onboarding/onboardingActionTypes';
import OnboardingTableFabrica from './OnboardingCompositeItemFabrica/OnboardingTableFabrica';

import './style.scss';


export const getValueObj = (type, value) => {
  console.log('🚀 ~ getValueObj ~ type:', type);
  let newValue = value;
  switch (type.type) {
    case 'DATE':
      newValue = dayjs(value).format('YYYY-MM-DD');
      break;
    case 'DATE_TIME':
      newValue = dayjs(value).format('YYYY-MM-DD HH:mm');
      break;
    case 'LIST_FIXED':
      return { value_text: newValue };
    default:
      break;
  }

  switch (type.submit_value_Type) {
    case 'VALUE_BOOLEAN':
      return { value_boolean: newValue };
    case 'VALUE_NUMBER':
      return { value_number: newValue };
    case 'VALUE_TEXT':
      return { value_text: newValue };
    case 'VALUE_BINARY_FILE':
      return {
        value_binary_file: {
          data: newValue,
          mime_type: 'application/pdf',
          name: 'document.pdf',
        },
      };
    default:
      return {};
  }
};

const OnboardingCategory = ({ item, wayPoint, onboardingPoints }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { search, pathname } = useLocation();
  const { onboardingId } = useParams();
  const contentRef = useRef(null);
  const query = useQuery(search);

  const userId = query.get('account-id');
  const category = query.get('category');
  const subCategory = query.get('sub-category');

  useEffect(() => {
    return () => {
      form.resetFields();
      setData(null);
    };
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [category, subCategory]);
  

  const { onboardingById, onboardingFormById, isEditing } = useSelector(
    (state) => state.onboardingReducer,
  );

  const isSubmiteRady = useMemo(() => {
    const isMandatory = (id, type = 'input') => {
      const result =
        type === 'input'
          ? onboardingFormById?.form_elements?.find(
              (i) => i.form_input_element?.id === id,
            )?.form_input_element?.min_number_of_submissions === 1
          : onboardingFormById?.form_elements?.find(
              (i) => i.form_composite_input_element?.id === id,
            )?.form_composite_input_element?.min_number_of_submissions === 1;
      return result;
    };
    if (onboardingById && onboardingFormById) {
      const mandatoryElements = onboardingFormById?.form_elements?.filter(
        (i) => i?.form_input_element?.min_number_of_submissions === 1,
      )?.length;
      const mandatoryCompositeElements =
        onboardingFormById?.form_elements?.filter(
          (i) =>
            i.form_composite_input_element?.min_number_of_submissions === 1,
        )?.length ?? 0;

      const submittedElementsArray =
        onboardingById?.form_input_element_submissions
          ?.filter((i) => isMandatory(i.form_input_element_id))
          ?.map((el) => el.form_input_element_id) ?? [];
      const submittedElements = new Set(submittedElementsArray).size;

      const submittedCompositeElementsArrey =
        onboardingById?.form_composite_input_element_submissions
          ?.filter((i) =>
            isMandatory(i.form_composite_input_element_id, 'composite'),
          )
          ?.map((el) => el.form_composite_input_element_id) ?? [];
      const submittedCompositeElements = new Set(
        submittedCompositeElementsArrey,
      ).size;

      const result =
        mandatoryElements +
        mandatoryCompositeElements -
        submittedElements -
        submittedCompositeElements;
      return {
        isSubmit: result === 0,
        input: { submitted: submittedElements, mandatory: mandatoryElements },
        composite: {
          submitted: submittedCompositeElements,
          mandatory: mandatoryCompositeElements,
        },
      };
    } else {
      return {
        isSubmit: false,
        input: { submitted: 0, mandatory: 0 },
        composite: { submitted: 0, mandatory: 0 },
      };
    }
  }, [onboardingById, onboardingFormById]);
  console.log('🚀 ~ OnboardingCategory ~ isSubmiteRady:', isSubmiteRady);

  const [data, setData] = useState(null);
  

  const isFormList = (id, type) => {
    let stored;
    if (type === 'input') {
      stored = onboardingFormById?.form_elements?.find(
        (i) => i.form_input_element?.id === id,
      );
    } else if (type === 'composite') {
      stored = onboardingFormById?.form_elements?.find(
        (i) => i.form_composite_input_element?.id === id,
      );
    }
    return (
      stored?.form_composite_input_element?.max_number_of_submissions ===
        null ||
      stored?.form_composite_input_element?.max_number_of_submissions > 1
    );
  };

  const datePickerValueFromSubmission = (valueText) => {
    if (valueText == null || valueText === '') {
      return undefined;
    }
    const parsed = dayjs(valueText);
    return parsed.isValid() ? parsed : undefined;
  };

  const coercePickerStoreValue = (val) => {
    if (val == null || val === '') {
      return undefined;
    }
    if (typeof val === 'object' && typeof val.isValid === 'function') {
      return val.isValid() ? val : undefined;
    }
    const parsed = dayjs(val);
    return parsed.isValid() ? parsed : undefined;
  };

  const sanitizeFormValuesForDatePickers = (formData, formElements) => {
    if (!formData || !formElements?.length) {
      return formData;
    }
    const out = { ...formData };
    formElements.forEach((row) => {
      const inputEl = row.form_input_element;
      if (
        inputEl?.id &&
        (inputEl.type === 'DATE' || inputEl.type === 'DATE_TIME')
      ) {
        out[inputEl.id] = coercePickerStoreValue(out[inputEl.id]);
        return;
      }
      const comp = row.form_composite_input_element;
      if (!comp?.id) {
        return;
      }
      const bucket = out[comp.id];
      if (bucket === undefined || bucket === null) {
        return;
      }
      const items = comp.form_composite_input_element_items ?? [];
      const dateChildIds = items
        .filter((it) => {
          const t = it?.form_input_element?.type;
          return t === 'DATE' || t === 'DATE_TIME';
        })
        .map((it) => it?.form_input_element?.id)
        .filter(Boolean);
      if (!dateChildIds.length) {
        return;
      }
      if (Array.isArray(bucket)) {
        out[comp.id] = bucket.map((rowObj) => {
          if (!rowObj || typeof rowObj !== 'object') {
            return rowObj;
          }
          const copy = { ...rowObj };
          dateChildIds.forEach((fid) => {
            if (Object.prototype.hasOwnProperty.call(copy, fid)) {
              copy[fid] = coercePickerStoreValue(copy[fid]);
            }
          });
          return copy;
        });
      } else if (typeof bucket === 'object') {
        const copy = { ...bucket };
        dateChildIds.forEach((fid) => {
          if (Object.prototype.hasOwnProperty.call(copy, fid)) {
            copy[fid] = coercePickerStoreValue(copy[fid]);
          }
        });
        out[comp.id] = copy;
      }
    });
    return out;
  };

  /** Тип поля по id: и корневые input, и вложенные в form_composite_input_element_items */
  const getInputElementTypeByFieldId = (formInputElementId) => {
    const elements = onboardingFormById?.form_elements;
    if (!elements?.length || formInputElementId == null) {
      return undefined;
    }
    const rootHit = elements.find(
      (el) => el.form_input_element?.id === formInputElementId,
    );
    if (rootHit?.form_input_element?.type) {
      return rootHit.form_input_element.type;
    }
    for (const row of elements) {
      const items =
        row.form_composite_input_element?.form_composite_input_element_items ??
        [];
      const nested = items.find(
        (it) => it?.form_input_element?.id === formInputElementId,
      );
      if (nested?.form_input_element?.type) {
        return nested.form_input_element.type;
      }
    }
    return undefined;
  };

  const hydrateRouteKeyRef = useRef('');

  useEffect(() => {
    if (onboardingById) {
      onboardingById?.editing_at &&
        dispatch({ type: START_ONBOARDING_EDIT.SUCCESS });
    }

    if (
      onboardingFormById &&
      (onboardingById?.form_input_element_submissions.length > 0 ||
        onboardingById?.form_composite_input_element_submissions.length > 0)
    ) {
      let dataForm = {};
      const storedData = [...onboardingById.form_input_element_submissions];
      const storedCompositeData = [
        ...onboardingById.form_composite_input_element_submissions,
      ];
      storedData.forEach((i) => {
        const input = onboardingFormById?.form_elements?.find(
          (el) => el.form_input_element?.id === i.form_input_element_id,
        );
        const listMulti =
          input?.form_input_element?.type === 'LIST_FIXED' &&
          !input?.form_input_element?.max_number_of_submissions;
        const dynamicMulti =
          (input?.form_input_element?.type === 'LIST_DYNAMIC' &&
          !input?.form_input_element?.max_number_of_submissions);
        const inputMulti =
          (input?.form_input_element?.type === 'EMAIL' &&
          !input?.form_input_element?.max_number_of_submissions ||
          input?.form_input_element?.max_number_of_submissions > 1);
        const fieldType =
          input?.form_input_element?.type ??
          getInputElementTypeByFieldId(i.form_input_element_id);
        const isDateField =
          fieldType === 'DATE' || fieldType === 'DATE_TIME';
        dataForm = {
          ...dataForm,
          [i.form_input_element_id]: isDateField
            ? datePickerValueFromSubmission(i?.value_text)
            : listMulti
              ? {
                  ...(dataForm?.[i.form_input_element_id] ?? {}),
                  [i.value_text]: true,
                }
              : dynamicMulti
                ? [...(dataForm?.[i.form_input_element_id] ?? []), i.value_text]
                : inputMulti
                  ? [...(dataForm?.[i.form_input_element_id] ?? []), {id: i.id, value_text: i.value_text}]
                  : (i?.value_text ?? i?.value_boolean ?? i?.value_number),
        };
      });
      storedCompositeData.forEach((i) => {
        const isMulti = isFormList(
          i.form_composite_input_element_id,
          'composite',
        );
        let composit = {};
        if (isMulti) {
          composit = {
            [i.form_composite_input_element_id]:
              dataForm?.[i.form_composite_input_element_id] ?? [],
          };
          let obj = { id: i.id };
          i.form_input_element_submissions.forEach((j) => {
            const subFieldType = getInputElementTypeByFieldId(
              j.form_input_element_id,
            );
            const isDateField =
              subFieldType === 'DATE' || subFieldType === 'DATE_TIME';
            obj = {
              ...obj,
              [j.form_input_element_id]: isDateField
                ? datePickerValueFromSubmission(j?.value_text)
                : (j?.value_text ?? j?.value_boolean ?? j?.value_number),
            };
          });
          composit[i.form_composite_input_element_id].push(obj);
          dataForm = { ...dataForm, ...composit };
        } else {
          composit = { [i.form_composite_input_element_id]: {} };
          i.form_input_element_submissions.forEach((j) => {
            const subFieldType = getInputElementTypeByFieldId(
              j.form_input_element_id,
            );
            const isDateField =
              subFieldType === 'DATE' || subFieldType === 'DATE_TIME';
            const fieldValue = isDateField
              ? datePickerValueFromSubmission(j?.value_text)
              : (j?.value_text ?? j?.value_boolean ?? j?.value_number);
            composit = {
              ...composit,
              [i.form_composite_input_element_id]: {
                ...composit[i.form_composite_input_element_id],
                [j.form_input_element_id]: fieldValue,
              },
            };
            dataForm = { ...dataForm, ...composit };
          });
        }
      });
      setData(dataForm);
    } else if (onboardingById && onboardingFormById) {
      setData({});
    }
  }, [onboardingById, onboardingFormById]);

  const subCategoryItem = useMemo(() => {
    const data = item?.subCategory?.find((i) => i.id === subCategory);
    return data ?? item;
  }, [subCategory, item]);

  const handleSaveOnbording = () => {
    form.submit();
  };

  useEffect(() => {
    if (!subCategoryItem?.form_elements?.length) {
      return;
    }
    const routeKey = `${onboardingById?.id ?? ''}|${category ?? ''}|${subCategory ?? ''}`;
    const schema =
      onboardingFormById?.form_elements?.length > 0
        ? onboardingFormById.form_elements
        : subCategoryItem.form_elements;
    /** Без схемы sanitize не трогает строки — не заливаем store до загрузки формы */
    if (!schema?.length) {
      return;
    }
    if (!data || Object.keys(data).length === 0) {
      if (hydrateRouteKeyRef.current !== routeKey) {
        hydrateRouteKeyRef.current = routeKey;
      }
      form.resetFields();
      return;
    }
    if (hydrateRouteKeyRef.current !== routeKey) {
      hydrateRouteKeyRef.current = routeKey;
      form.resetFields();
    }
    form.setFieldsValue(sanitizeFormValuesForDatePickers(data, schema));
  }, [
    data,
    subCategoryItem,
    onboardingFormById,
    onboardingById?.id,
    category,
    subCategory,
    form,
  ]);

  const nextCategory = useMemo(() => {
    const index = wayPoint.indexOf(subCategory ?? category);
    if (index + 1 >= wayPoint.length) return null;
    const nestId = wayPoint[index + 1];
    const isCategory =
      onboardingPoints.find((i) => i.id === nestId)
        ?.parent_form_element_group_id === null;
    const categoryIdBiSub = (id) => {
      const category = onboardingPoints.find((i) =>
        i.subCategory.find((j) => j.id === id),
      )?.id;
      return category;
    };
    if (isCategory) {
      return { category: nestId, subCategory: null };
    } else {
      return { category: categoryIdBiSub(nestId), subCategory: nestId };
    }
  }, [subCategory, wayPoint, category]);

  const goToNextCategory = () => {
    const newQuery = new URLSearchParams(search);
    newQuery.set('category', nextCategory.category);
    nextCategory.subCategory
      ? newQuery.set('sub-category', nextCategory.subCategory)
      : newQuery.delete('sub-category');
    history.replace({
      pathname,
      search: `?${newQuery.toString()}`,
    });
  };

  const getTypeFormItem = (item, compositeId) => {
    if (!compositeId) {
      const form_element = onboardingFormById?.form_elements?.find(
        (i) => i.form_input_element?.id === item.id,
      );
      if (form_element) {
        return {
          type: form_element?.form_input_element?.type,
          valueType: form_element?.form_input_element?.submit_value_Type,
          multi:
            !Object.hasOwn(
              form_element?.form_input_element,
              'max_number_of_submissions',
            ) ||
            form_element?.form_input_element?.max_number_of_submissions ===
              null,
        };
      } else {
        return null;
      }
    } else {
      const form_element = onboardingFormById?.form_elements?.find(
        (i) => i.form_composite_input_element?.id === compositeId,
      );
      if (form_element) {
        return {
          type: form_element?.form_composite_input_element?.form_composite_input_element_items.find(
            (i) => i.form_input_element?.id === item.id,
          )?.form_input_element?.type,
          valueType:
            form_element?.form_composite_input_element?.form_composite_input_element_items.find(
              (i) => i.form_input_element?.id === item.id,
            )?.form_input_element?.submit_value_Type,
        };
      } else {
        return null;
      }
    }
  };


  const compareCompositeItemValues = (
    compositeItem,
    existingSubmission,
    compositeId,
  ) => {
    if (
      !existingSubmission ||
      !existingSubmission.form_input_element_submissions
    ) {
      return true;
    }

    const existingFieldsCount =
      existingSubmission.form_input_element_submissions?.length || 0;
    const submittedFieldsCount = Object.keys(compositeItem).filter(
      (key) => key !== 'id',
    ).length;

    if (existingFieldsCount !== submittedFieldsCount) {
      return true;
    }

    for (const fieldId in compositeItem) {
      if (fieldId === 'id') continue;

      const type = getTypeFormItem(
        { id: fieldId, value: compositeItem[fieldId] },
        compositeId,
      );
      if (!type) continue;

      const valueTarget = type?.valueType?.toLowerCase();
      let newValue = compositeItem[fieldId];

      if (newValue === null || newValue === undefined) {
        newValue = null;
      } else {
        if (type.type === 'DATE') {
          newValue = dayjs(newValue).isValid()
            ? dayjs(newValue).format('YYYY-MM-DD')
            : null;
        } else if (type.type === 'DATE_TIME') {
          newValue = dayjs(newValue).isValid()
            ? dayjs(newValue).format('YYYY-MM-DD HH:mm')
            : null;
        }
      }

      const existingField =
        existingSubmission.form_input_element_submissions?.find(
          (i) => i.form_input_element_id === fieldId,
        );
      const oldValue = existingField?.[valueTarget];

      if (
        newValue !== oldValue &&
        (newValue !== null || oldValue !== null) &&
        (newValue !== undefined || oldValue !== undefined)
      ) {
        return true;
      }
    }

    const submittedFieldIds = Object.keys(compositeItem).filter(
      (key) => key !== 'id',
    );
    for (const existingField of existingSubmission.form_input_element_submissions ||
      []) {
      if (!submittedFieldIds.includes(existingField.form_input_element_id)) {
        return true;
      }
    }

    return false;
  };

  const changesId = (id, value) => {
    const composite = onboardingFormById?.form_elements?.find(
      (i) => i.form_composite_input_element?.id === id,
    );
    const isComposite = !!composite;

    if (isComposite && Array.isArray(value)) {
      const existingElements =
        onboardingById?.form_composite_input_element_submissions?.filter(
          (i) => i.form_composite_input_element_id === id,
        );
      return existingElements && existingElements.length > 0
        ? 'array'
        : 'create';
    }

    const element = isComposite
      ? onboardingById?.form_composite_input_element_submissions?.find(
          (i) => i.form_composite_input_element_id === id,
        )
      : onboardingById?.form_input_element_submissions?.find(
          (i) => i.form_input_element_id === id,
        );
    if (!isComposite) {
      if (element) {
        const type = getTypeFormItem({ id }, null);
        const valueTarget = type?.valueType?.toLowerCase();
        if (type.type === 'DATE') {
          value = dayjs(value).format('YYYY-MM-DD');
        }
        if (type.type === 'DATE_TIME') {
          value = dayjs(value).format('YYYY-MM-DD HH:mm');
        }
        const old = element?.[valueTarget];
        return value !== old ? element?.id : false;
      } else {
        return 'create';
      }
    } else if (isComposite) {
      if (!element) {
        return 'create';
      }
      let compositeNeedSaveArray = [];
      for (const el in value) {
        const type = getTypeFormItem({ id: el }, id);
        const valueTarget = type?.valueType?.toLowerCase();
        if (type.type === 'DATE') {
          value = dayjs(value).format('YYYY-MM-DD');
        }
        if (type.type === 'DATE_TIME') {
          value = dayjs(value).format('YYYY-MM-DD HH:mm');
        }
        const old = element?.form_input_element_submissions?.find(
          (i) => i.form_input_element_id === el,
        )?.[valueTarget];
        compositeNeedSaveArray.push(value !== old);
      }
      return compositeNeedSaveArray.includes(true) ? element?.id : false;
    }
  };

  const storedFixedMulti = (id) => {
    return onboardingById?.form_input_element_submissions?.filter(
      (i) => i.form_input_element_id === id,
    );
  };
// TODO rework!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const onSubmit = (data) => {
    console.log('data', data);
    for (const item in data) {
      if (data[item] === null || data[item] === undefined) {
        continue;
      }
      const needSave = changesId(item, data[item]);
      const type = getTypeFormItem({ id: item, value: data[item] });
      if (type?.type === 'LIST_DYNAMIC' && type?.multi) {
        console.log('LIST_DYNAMIC', item, '\n', data[item]);
        const stored = storedFixedMulti(item);
        stored.forEach((el) => {
          if (!data[item].includes(el?.[type?.valueType?.toLowerCase()])) {
            dispatch(deleteFormInputElement(el.id));
          }
        });
        data[item].forEach((el) => {
          const needSave = !stored.find(
            (j) => j?.[type?.valueType?.toLowerCase()] === el,
          );
          const obj = {
            form_input_element_id: item,
            form_submission_id: onboardingById?.id,
            [type?.valueType?.toLowerCase()]: el,
          };
          needSave && dispatch(createFormInputElement(obj));
        });
      } else if (type?.type === 'LIST_FIXED' && type?.multi) {
        const result = Object.entries(data[item])
          .filter(([_, value]) => value === true)
          .map(([key]) => key);
        const stored = storedFixedMulti(item);
        stored.forEach((el) => {
          if (!result.includes(el?.[type?.valueType?.toLowerCase()])) {
            dispatch(deleteFormInputElement(el.id));
          }
        });
        result?.forEach((i) => {
          const needSave = !stored.find(
            (j) => j?.[type?.valueType?.toLowerCase()] === i,
          );
          const obj = {
            form_input_element_id: item,
            form_submission_id: onboardingById?.id,
            [type?.valueType?.toLowerCase()]: i,
          };
          needSave && dispatch(createFormInputElement(obj));
        });
      } else if (
        typeof data[item] !== 'object' ||
        (typeof data[item] === 'object' &&
          (type?.type === 'DATE' || type?.type === 'DATE_TIME'))
      ) {
        const obj = {
          form_input_element_id: item,
          form_submission_id: onboardingById?.id,
          ...getValueObj(type, data[item]),
        };
        needSave === 'create'
          ? dispatch(createFormInputElement(obj))
          : needSave
            ? dispatch(editFormInputElement({ id: needSave, ...obj }))
            : null;
      } else {
        if (Array.isArray(data[item])) {
          const compositeId = item;
          const compositeArray = data[item];

          const existingSubmissions =
            onboardingById?.form_composite_input_element_submissions?.filter(
              (i) => i.form_composite_input_element_id === compositeId,
            ) || [];

          compositeArray.forEach((compositeItem) => {
            if (!compositeItem || typeof compositeItem !== 'object') {
              return;
            }
            const obj = {
              form_composite_input_element_id: compositeId,
              form_submission_id: onboardingById?.id,
              form_input_element_submissions: [],
            };

            for (const fieldId in compositeItem) {
              if (fieldId === 'id') continue;
              const type = getTypeFormItem(
                { id: fieldId, value: compositeItem[fieldId] },
                compositeId,
              );
              const compositeObj = {
                form_input_element_id: fieldId,
                form_submission_id: onboardingById?.id,
                ...getValueObj(type, compositeItem[fieldId]),
              };
              obj.form_input_element_submissions.push(compositeObj);
            }

            if (compositeItem.id) {
              const existingSubmission = existingSubmissions.find(
                (i) => i.id === compositeItem.id,
              );

              if (existingSubmission) {
                const hasChanges = compareCompositeItemValues(
                  compositeItem,
                  existingSubmission,
                  compositeId,
                );

                if (hasChanges) {
                  dispatch(
                    editCompositeInputElement({ id: compositeItem.id, ...obj }),
                  );
                }
              } else {
                dispatch(createCompositeInputElement(obj));
              }
            } else {
              dispatch(createCompositeInputElement(obj));
            }
          });

          const submittedIds = compositeArray
            .map((item) => item.id)
            .filter(Boolean);

          existingSubmissions.forEach((existingItem) => {
            if (!submittedIds.includes(existingItem.id)) {
              dispatch(deleteCompositeInputElement(existingItem.id));
            }
          });
        } else {
          const compositeId = item;
          const composite = data[item];
          const obj = {
            form_composite_input_element_id: compositeId,
            form_submission_id: onboardingById?.id,
            form_input_element_submissions: [],
          };
          for (const item in composite) {
            const type = getTypeFormItem(
              { id: item, value: composite[item] },
              compositeId,
            );
            const compositeObj = {
              form_input_element_id: item,
              form_submission_id: onboardingById?.id,
              ...getValueObj(type, composite[item]),
            };
            obj.form_input_element_submissions.push(compositeObj);
          }
          needSave === 'create'
            ? dispatch(createCompositeInputElement(obj))
            : needSave
              ? dispatch(editCompositeInputElement({ id: needSave, ...obj }))
              : null;
        }
      }
    }
    dispatch(getOnboardingById(onboardingId));
    console.log('+++++++++++++++++++++++++++++++++');
    console.log('🚀 ~ onSubmit ~ nextCategory:', nextCategory);
    nextCategory && goToNextCategory();
  };

  const handleChange = () => {
    
  };
  
  const handleStartEditOnbording = () => {
    if (onboardingById?.id) {
      dispatch(startOnboardingEdit(onboardingById?.id));
    }
  };

  const handleStopEditOnbording = () => {
    if (onboardingById?.id) {
      dispatch(stopOnboardingEdit(onboardingById?.id));
      history.replace(`/accounts/${userId}/inform/onboarding`);
    }
  };

  const handleSubmitOnbording = () => {
    if (onboardingById?.id) {
      dispatch(submitOnboarding(onboardingById?.id));
      history.replace(`/accounts/${userId}/inform/onboarding`);
    }
  };

  const notEditableList = ['SUBMITTED', 'CANCELED', 'COMPLETED'];

  const hasEdining = useMemo(() => {
    return onboardingById?.status
      ? ['AVAILABLE'].includes(onboardingById?.status)
      : false;
  }, [onboardingById?.status]);

  const isSubmitAllowed = (status) => {
    return ['AVAILABLE', 'EDITING'].includes(status);
  };

  const isShowDependence = useCallback((id, value) => {
    if(value === undefined || value === null) return true;
    const observation = onboardingById?.form_input_element_submissions?.filter(
      (i) => i.form_input_element_id === id,
    ).map(i => i.value_text);

    if (observation.length > 0) {
      const result = observation?.includes(value);
      console.log('🚀 ~ OnboardingCategory ~ result:', result);
      return result;
    } else {
      return false;
    }
  }, [onboardingById?.form_input_element_submissions]);

  const handleBack = () => {
    history.replace(`/accounts/${userId}/inform/onboarding`);
  };

  return (
    <div className="onboarding-right-wrapper">
      <header className="onboarding-right-header">
          <Button
            icon={<GoBackIcon />}
            iconPosition="end"
            className={'add-btn-whith-icon'}
            onClick={handleBack}
          >
            <Text>{t('GO_BACK')}</Text>
          </Button>
        {hasEdining ? (
          <Button
            icon={<EditIcon />}
            iconPosition="end"
            className={'add-btn-whith-icon'}
            onClick={handleStartEditOnbording}
            // disabled={notEditableList.includes(onboardingById?.status)}
          >
            <Text>{t('START_EDIT')}</Text>
          </Button>
        ) : ['EDITING'].includes(onboardingById?.status) ? (
          <Button
            icon={<EditIcon />}
            iconPosition="end"
            className={'add-btn-whith-icon'}
            onClick={handleStopEditOnbording}
          >
            <Text>{t('STOP_EDIT')}</Text>
          </Button>
        ) : null}
        <Button
          disabled={
            !isSubmitAllowed(onboardingById?.status) || !isSubmiteRady.isSubmit
          }
          icon={<Cancel />}
          iconPosition="end"
          className={'add-btn-whith-icon'}
          onClick={handleSubmitOnbording}
        >
          <Text>{t('SUBMIT')}</Text>
        </Button>
      </header>
      <div className="onbording-card card-right">
        <div ref={contentRef} style={{ overflowY: 'auto' }} className="onbording-content-wrapper">
          <h2 className="onbording-card-header category-title">
            {t(item?.description)}
          </h2>
          <h3 className="category-sub-title">
            {t(subCategoryItem?.description)}
          </h3>
          <div className="onboarding-item-fabrica-wrapper">
            <Form
              form={form}
              disabled={!isEditing}
              name="onboarding-form"
              layout="vertical"
              className="instrument-form model-settings"
              autoComplete="off"
              validateTrigger="onBlur"
            >
              {onboardingById &&
                subCategoryItem?.form_elements?.map((i) => (
                  isShowDependence(i.form_input_element?.dependence?.input_id, i.form_input_element?.dependence?.value) && (

                  <div key={i.element_order} 
                    style={{ marginBottom: '24px', width: i.form_input_element?.size ? i.form_input_element?.size : '100%' }}>
                    {Object.hasOwn(i, 'form_input_element') && (
                      <OnboardingItemFabrica
                        formItem={i}
                        onboardingId={onboardingById?.id}
                        onChange={handleChange}
                        form={form}
                      />
                    )}
                      {Object.hasOwn(i, 'form_composite_input_element') && i.form_composite_input_element?.display === 'table' && (
                        <OnboardingTableFabrica formItem={i} />
                      )}
                      {Object.hasOwn(i, 'form_composite_input_element') && i.form_composite_input_element?.display !== 'table' && (
                        <OnboardingCompositeItemFabrica formItem={i} />
                      )}
                    {Object.hasOwn(i, 'form_action_element') && (
                      <OnboardingActionItemFabrica
                        formItem={i}
                        onboardingId={onboardingById?.id}
                      />
                    )}
                  </div>
                  )
                ))}
            </Form>
          </div>
        </div>
        {/* <Button
          disabled={!isEditing}
          icon={<Confirm />}
          iconPosition="end"
          type="text"
          className="start-onbording-btn"
          onClick={handleSaveOnbording}
        >
          {t('CONFIRM')}
        </Button> */}
      </div>
    </div>
  );
};

export default OnboardingCategory;

OnboardingCategory.propTypes = {
  item: PropTypes.object,
  wayPoint: PropTypes.array,
  onboardingPoints: PropTypes.array,
};
